module.exports = __webpack_public_path__ + "img/yf.c5353ca5.png";